import { Component, OnInit, AfterViewChecked, AfterViewInit } from '@angular/core';
import _ from 'underscore';

// ALC router part https://angular.io/guide/router-tutorial-toh#add-the-logincomponent
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

/* Add Amplify imports */
import { AmplifyUIAngularModule } from '@aws-amplify/ui-angular';
// import Amplify, {Auth} from 'aws-amplify';
// import awsconfig from '../../aws-exports';
/*ALC [Utilities \- Hub \- Amplify Docs](https://docs.amplify.aws/lib/utilities/hub/q/platform/js)*/
import { Hub } from 'aws-amplify';

/* Configure Amplify resources */
// Amplify.configure(awsconfig);

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit { // implements OnInit, AfterViewChecked, AfterViewInit
  ngOnInit(): void {
  }

  // tslint:disable-next-line:max-line-length
  // Replaced by standard [Authentication \- Authenticator \- Amplify Docs](https://docs.amplify.aws/ui/auth/authenticator/q/framework/angular)
  /*// email = '';
  // password = '';
  message: string;
  constructor(public authService: AuthService, public router: Router) {
    this.setMessage();
/!*    Hub.listen('auth', (data) => {
      console.log('Listening for all messages: ', data.payload.data);
      this.onAuthEvent(data.payload);
    });*!/
  }

  setMessage(): void {
    this.message = 'Logged ' + (this.authService.isLoggedIn ? 'in' : 'out');
  }

  login(): void {
    this.message = 'Trying to log in ...';

/!*    this.authService.checkIsLoggedIn().subscribe((data) => {
      this.setMessage();
      if (this.authService.isLoggedIn) {
        // Usually you would use the redirect URL from the auth service.
        // However to keep the example simple, we will always redirect to `/admin`.
        const redirectUrl = this.authService.redirectUrl ?? '/home';

        // Redirect the user
        this.router.navigate([redirectUrl]);
      }
    });*!/
  }

  logout(): void {
    this.authService.logout();
    this.setMessage();
  }

  reloadCurrentRoute(): void {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.router.navigate([currentUrl]);
      console.log(currentUrl);
    });
  }
  ngOnInit(): void {
    console.log( 'ngOnInit' );
    // this.login();
  }
  ngAfterViewChecked(): void {
    console.log( 'ngAfterViewChecked' );
  }
  ngAfterViewInit(): void {
    console.log( 'ngAfterView' );
  }
/!*  onAuthEvent(payload): void {
    // ... your implementation
    if (payload && payload.event && payload.event === 'signIn'){
      console.log(payload.message);
    }
    if (payload && payload.event && payload.event === 'AuthStateChange' && payload.message && payload.message === 'signedout'){
      console.log(payload.message);
    }
  }*!/
  loginWithCognito = () => {
    alert(JSON.stringify(_.omit(this, 'register', '__ngContext__' , '__proto__')));
  }*/

}
